import React from 'react';
import { Route } from "react-router-dom";
import EntityGroupsList from './entity_groups.list';
import EntityGroupView from './entity_group.view';
import store from './filterStore';

const EntityGroupsRouter = ({ match }) => (
  <div>
    <Route path={`${match.path}/:id`} component={EntityGroupView} />
    <Route
      exact
      path={match.path}
      render={() => <EntityGroupsList store={store} />}
    />
  </div>
);

export default EntityGroupsRouter;
